module.exports = __webpack_public_path__ + "img/Z81_16.3d1643f5.jpg";